import { __decorate } from "tslib";
import { Component, Ref, Vue } from "../../../vue";
import { openWConsoleModal } from "../../WConsole/child";
import { IMethodEditorState } from "../MethodEditorState";
import styles from "./MethodDebugger.module.css";
import commonStyles from "../../../style/class.module.css";
import { fromJsonData } from '@tencent/data-schema-core/lib/convertor/jsonData';
import { isEqualForDataSchema } from "../../../tools/schema/isEqualDataSchema";
import { message } from 'ant-design-vue';
const editorElRefName = 'debugEditor';
let MethodDebugger = class MethodDebugger extends Vue {
  constructor() {
    // _tsx:DeclareProps<Pick<MethodDebugger,''>>
    super(...arguments);
    this.isShowProcesses = false;
  }
  mounted() {
    if (this.editorEl) {
      this.state.initDebugEditor(this.editorEl);
    }
  }
  onSaveAndDebug() {
    this.state.debug();
  }
  openServerLog() {
    var _wContext$config, _wContext$config2;
    const {
      wContext
    } = this.state.options.pageConfig;
    const pageId = (_wContext$config = wContext.config) === null || _wContext$config === void 0 ? void 0 : _wContext$config.pageId;
    const projectId = (_wContext$config2 = wContext.config) === null || _wContext$config2 === void 0 ? void 0 : _wContext$config2.projectId;
    openWConsoleModal(projectId, pageId);
  }
  get processesToShow() {
    const {
      schemaProcesses,
      designer,
      sourceInstance
    } = this.state;
    if (!sourceInstance) return [];
    const schemaOption = {
      designer,
      instance: sourceInstance
    };
    const {
      isDB
    } = sourceInstance;
    const dbHiddenIds = ['_id', '_ctime', '_mtime', '_owner'];
    const showProcesses = schemaProcesses.filter(item => item.show(schemaOption)).filter(item => {
      var _sourceInstance$state;
      const value = sourceInstance[item.variableName];
      const newSchema = fromJsonData(value);
      const oldSchema = (_sourceInstance$state = sourceInstance.stateSchema.fields) === null || _sourceInstance$state === void 0 ? void 0 : _sourceInstance$state.find(f => f.id === item.variableName);
      if (!oldSchema) return false;
      const isEqual = isEqualForDataSchema(newSchema, oldSchema, isDB ? dbHiddenIds : []);
      return !isEqual;
    });
    return showProcesses;
  }
  get hasProcessesToShow() {
    return !!this.processesToShow.length;
  }
  toggleProcessesShow() {
    if (!this.hasProcessesToShow) return;
    this.isShowProcesses = !this.isShowProcesses;
  }
  renderUpdateSchemas() {
    const h = this.$createElement;
    const {
      designer,
      sourceInstance
    } = this.state;
    if (!sourceInstance || !this.hasProcessesToShow || !this.isShowProcesses) return null;
    const schemaOption = {
      designer,
      instance: sourceInstance
    };
    const showProcesses = this.processesToShow;
    const onClick = item => {
      const res = item.func(schemaOption);
      if (res.succ) {
        message.success('类型已更新成功');
      } else {
        message.error('类型更新失败');
      }
    };
    return h("div", {
      "class": styles.updateSchema,
      "key": "updateSchema"
    }, [h("div", {
      "class": styles.updateSchemaTip
    }, ["\u68C0\u6D4B\u5230\u4EE5\u4E0B\u53D8\u91CF\u7C7B\u578B\u548C\u5B9E\u4F53\u4E0D\u4E00\u81F4\uFF0C\u53EF\u70B9\u51FB\u66F4\u65B0\u53D8\u91CF\u7C7B\u578B\uFF1B\u82E5\u60F3\u548C\u6570\u636E\u6E90\u5B9E\u4F53\u7C7B\u578B\u4FDD\u6301\u4E00\u81F4\uFF0C\u8BF7\u52FF\u70B9\u51FB\u3002"]), h("a-space", {
      "attrs": {
        "direction": "vertical"
      }
    }, [showProcesses.map(item => h("a-button", {
      "attrs": {
        "type": "primary",
        "size": "small"
      },
      "class": styles.debugBtn,
      "on": {
        "click": () => onClick(item)
      }
    }, ["\u66F4\u65B0 ", item.variableName, " \u53D8\u91CF\u7C7B\u578B"]))])]);
  }
  render() {
    const h = arguments[0];
    let updateSchemaDom = null;
    try {
      updateSchemaDom = this.renderUpdateSchemas();
    } catch (error) {
      console.error('updateSchemaDom error:', error);
    }
    return h("div", {
      "class": styles.debug
    }, [h("div", {
      "style": "margin-bottom:4px;"
    }, [h("span", {
      "class": commonStyles.label,
      "style": "margin:0 8px 0 0;"
    }, ["\u8C03\u7528\u4EE3\u7801"]), h("a-button", {
      "attrs": {
        "type": "primary",
        "icon": "caret-right",
        "size": "small",
        "wj-eid": "保存并调试"
      },
      "class": styles.debugBtn,
      "on": {
        "click": this.onSaveAndDebug
      }
    }, ["\u4FDD\u5B58\u5E76\u8C03\u8BD5(F5)"]), this.hasProcessesToShow && h("a-tooltip", {
      "attrs": {
        "title": "查看有哪些变量有类型变更",
        "placement": "topRight"
      }
    }, [h("a-button", {
      "class": styles.processesBtn,
      "attrs": {
        "type": "link",
        "icon": "eye"
      },
      "on": {
        "click": this.toggleProcessesShow
      }
    })])]), updateSchemaDom, h("div", {
      "key": "editorForDebug",
      "class": styles.script,
      "ref": editorElRefName
    }), h("p", {
      "class": commonStyles.label,
      "style": "margin-top:12px;"
    }, ["\u65E5\u5FD7\u67E5\u770B", h("a-tooltip", {
      "attrs": {
        "title": h("p", ["\u53EF\u4EE5\u5728\u65B9\u6CD5\u4EE3\u7801\u6216\u8C03\u7528\u4EE3\u7801\u4E2D\u4F7F\u7528`console.log`\u8FDB\u884C\u5B9E\u65F6\u6253\u5370\u65E5\u5FD7"])
      }
    }, [h("span", {
      "class": styles.toolTip
    }, ["\u5982\u4F55\u6253\u5370\u65E5\u5FD7"])]), h("a-button", {
      "on": {
        "click": this.openServerLog
      },
      "attrs": {
        "size": "small",
        "wj-eid": "查看服务器日志"
      }
    }, ["\u67E5\u770B\u670D\u52A1\u5668\u65E5\u5FD7"])]), h("div", {
      "class": styles.showLog
    }, [h("a-textarea", {
      "attrs": {
        "value": this.state.logState.logText,
        "disabled": true
      },
      "style": "height: 100%;"
    })])]);
  }
};
__decorate([IMethodEditorState], MethodDebugger.prototype, "state", void 0);
__decorate([Ref(editorElRefName)], MethodDebugger.prototype, "editorEl", void 0);
MethodDebugger = __decorate([Component({
  name: 'MethodDebugger'
})], MethodDebugger);
export default MethodDebugger;
//# sourceMappingURL=MethodDebugger.js.map
